"use client";
import React from "react";
import {
  Button,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import nails from "../images/nails.jpeg";

function MiniAbout() {
  const navigate = useNavigate();

  return (
    <Stack direction={{ base: "column", md: "row" }}>
      <Flex flex="0 0 40%">
        <Image
          alt={"About Annie-Nails"}
          width={"100%"}
          objectFit={"cover"}
          src={nails}
        />
      </Flex>
      <Flex p={8} flex="1" align={"center"} justify={"center"}>
        <Stack spacing={6} w={"full"} maxW={"lg"}>
          <Heading fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}>
            <Text
              as={"span"}
              position={"relative"}
              color={"#4d4d4d"}
              _after={{
                content: "''",
                width: "full",
                height: useBreakpointValue({ base: "20%", md: "30%" }),
                position: "absolute",
                bottom: 1,
                left: 0,
                bg: "#FFB6C1",
                zIndex: -1,
              }}
            >
              About
            </Text>
            <br />{" "}
            <Text color={"#FFB6C1"} as={"span"}>
              Annie's Beauty & Spa
            </Text>{" "}
          </Heading>
          <Text fontSize={{ base: "md", lg: "lg" }} color={"gray.500"}>
            Our salon is committed to excellence and provides the bridge where
            luxury meets relaxation. Step into our serene oasis and leave your
            worries behind.
          </Text>
          <Stack direction={{ base: "column", md: "row" }} spacing={4}>
            <Button
              rounded={"full"}
              bg={"pink.300"}
              color={"white"}
              _hover={{
                bg: "pink.400",
              }}
              onClick={()=>{navigate("/services")}}
            >
              Book Now
            </Button>
            <Button rounded={"full"} onClick={() => {navigate("/about")}}>
              About Us
            </Button>
          </Stack>
        </Stack>
      </Flex>
    </Stack>
  );
}

export default MiniAbout;
